import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Card } from 'semantic-ui-react';

import { getString } from '../../utils';
import BlockHeader from '../BlockHeader';
import SponsorCard from './SponsorCard';

const SponsorsBlock = ({ sponsors, header, headerLevel, itemProps, itemsPerRow }) => {
  if (!sponsors || sponsors.length === 0) return null;
  // header={null} permet de masquer complètement le titre
  const title = header === null ? null : header || getString('blocks.sponsors');
  return (
    <>
      {title && <BlockHeader title={title} headerLevel={headerLevel} />}
      <Card.Group centered itemsPerRow={itemsPerRow}>
        {sponsors.map((sponsor) => (
          <SponsorCard key={sponsor._id} {...itemProps} item={sponsor} />
        ))}
      </Card.Group>
    </>
  );
};
SponsorsBlock.defaultProps = {
  dataSource: undefined,
  header: undefined,
  headerLevel: undefined,
  ids: undefined,
  itemProps: undefined,
  itemsPerRow: undefined,
};
SponsorsBlock.propTypes = {
  // ownProps consommées par le connect
  dataSource: PropTypes.shape({ kind: PropTypes.string, collection: PropTypes.string }),
  ids: PropTypes.arrayOf(PropTypes.string),
  header: PropTypes.string,
  headerLevel: PropTypes.string,
  itemProps: PropTypes.object,
  itemsPerRow: PropTypes.number,
  sponsors: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default connect((state, props) => {
  const { collection = 'sponsors' } = props.dataSource || {};
  return {
    sponsors: (props.ids || [])
      .map((id) => state.users.collections[collection]?.usersById[id])
      .filter((v) => v),

    // sponsors: (props.ids || []).map((id) => state.sponsors.sponsorsById[id]).filter((v) => v),
  };
})(SponsorsBlock);
